import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable, of, map } from 'rxjs';

/**
 *Guard para proteger rutas en donde es requerido que exista un queryParams llamado email
 *
 * @export
 * @class EmailParamGuard
 * @implements {CanActivate}
 */
@Injectable({
  providedIn: 'root',
})
export class EmailParamGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return of(route.queryParams).pipe(
      map(({ email }) => email as string),
      map((email) => {
        if (email) {
          return true;
        } else {
          return this.router.createUrlTree(['/']);
        }
      })
    );
  }
}
